<template>
  <li
    :class="{
      'tabs-title': true,
      'is-active': active,
    }"
  >
    <a @click="onTabClick">
      <emoji-or-icon v-if="icon" class="icon" :icon="icon" :icon-size="16" />
      {{ name }}
      <span v-if="showBadge" class="badge">
        {{ getItemCount }}
      </span>
      <span
        v-if="chevron"
        class="chevron-icon__wrap"
        :class="{ 'is-open': isOpen }"
      >
        <fluent-icon size="16" icon="chevron-down" />
      </span>
    </a>
  </li>
</template>

<script>
import EmojiOrIcon from 'shared/components/EmojiOrIcon';

export default {
  name: 'WootTabsItem',
  components: { EmojiOrIcon },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: '',
    },
    chevron: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    active() {
      return this.index === this.$parent.index;
    },

    getItemCount() {
      return this.count;
    },
  },

  methods: {
    onTabClick(event) {
      event.preventDefault();
      if (!this.disabled) {
        this.$parent.$emit('change', this.index);
      }
    },
  },
};
</script>

<style scoped>
.icon {
  margin-right: 5px;
}

.chevron-icon__wrap {
  display: inline-flex;
  margin-left: 4px;
  color: var(--color-medium-gray);
}

.chevron-icon__wrap svg {
  transition: transform 0.3s ease;
}

.chevron-icon__wrap.is-open svg {
  transform: rotate(180deg);
}
</style>
